<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Kirim Balik</h5>
            </template>
            <b-row class="align-items-center">
                <b-col cols="12" md="6">
                    <b-form-group label="No. Faktur">
                        <b-form-input
                            v-model="input.filterNoFaktur" name="filterNoFaktur"
                            type="search"
                            placeholder="Masukkan no. faktur"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Status">
                        <b-form-select v-model="input.filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih status --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Cabang">
                        <multiselect
                            class="ml-0"
                            name="filterCabang"
                            v-model="input.filterCabang"
                            :options="cabangOption"
                            :internal-search="true"
                            :allow-empty="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="-- Pilih filter cabang --"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="d-flex flex-wrap align-items-center justify-content-between">
                <div class="mb-3">
                    <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter">
                        <i class="fa fa-search"></i>
                    </b-button>
                    <b-button variant="danger" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                </div>
                <div class="mb-3" v-if="$helper.hasPermissionMenuChildren('LOK')">
                    <b-button variant="pgiBtn" @click="$bvModal.show('m-create')">Request Kirim Balik Baru</b-button>
                </div>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="dataKirimBalik" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada permintaan kirim balik.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <div>{{row.item.noFaktur}}</div>
                    <div class="smallText text-muted">{{(row.item.lokasi != null) ?row.item.lokasi :"-" }}</div>
                </template>
                <template v-slot:cell(diajukanOleh)="row">
                    <div>{{row.item.createdBy}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormat(row.item.createdAt)}} {{$helper.changeDateFormatGetHour(row.item.createdAt)}}</div>
                </template>
                <template v-slot:cell(barang)="row">
                    <div>
                        <p class="mb-0">{{row.item.jenis}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge v-if="statusBadge[row.item.status]" :variant="statusBadge[row.item.status].variant" :class="statusBadge[row.item.status].class">{{ statusBadge[row.item.status].text }}</b-badge>
                    <div v-if="requestPurpose(row.item)" class="smallText text-muted mt-1">{{ requestPurpose(row.item) }}</div>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Info" @click="openDetail(row.item)">
                            <i class="fa fa-fw fa-info"></i>
                        </b-button>
                        <b-button v-if="row.item.status == 'DITERIMA' && $helper.hasPermissionMenuChildren('LOK')" size="sm" class="ml-2" variant="warning" v-b-tooltip.hover.top title="Kirim ke Cabang" @click="openModalKirimCabang(row.item)">
                            <i class="fa fa-fw fa-truck"></i>
                        </b-button>
                        <b-button v-if="row.item.status == 'DIKIRIM_KE_CABANG' && $helper.hasPermissionMenuChildren('LOC')" size="sm" class="ml-2" variant="success" v-b-tooltip.hover.top title="Terima di Cabang" @click="openModalConfirmTerimaCabang(row.item.id)">
                            <i class="fa fa-fw fa-check"></i>
                        </b-button>
                        <b-button v-if="row.item.status == 'PENGIRIMAN' && $helper.hasPermissionMenuChildren('LOK')" size="sm" class="ml-2" v-b-tooltip.hover.top title="Terima" variant="success" @click="openModalConfirmTerima(row.item)">
                            <i class="fa fa-fw fa-check"></i>
                        </b-button>
                        <b-button v-if="canRequestWriteOff(row.item)" size="sm" class="ml-2" variant="danger" v-b-tooltip.hover.top title="Ajukan Barang Hilang" @click="openModalWriteOff(row.item)">
                            <i class="fa fa-fw fa-file-text-o"></i>
                        </b-button>
                        <b-button v-if="['DIAJUKAN', 'MENUNGGU_PEMBAYARAN'].includes(row.item.status) && $helper.hasPermissionMenuChildren('LOK')" size="sm" class="ml-2" variant="info" v-b-tooltip.hover.top title="Ubah Lokasi Barang" @click="openModalUpdateLocation(row.item)">
                            <i class="fa fa-fw fa-map-marker"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DIAJUKAN</h6>
                <p class="smallText mb-0">Pengajuan menunggu tindak lanjut dari pihak Sinar Mutiara.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">MENUNGGU PEMBAYARAN</h6>
                <p class="smallText mb-0">Menunggu nasabah melakukan pembayaran sebelum barang lelangan dikirim kembali.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENGIRIMAN</h6>
                <p class="smallText mb-0">Barang lelangan sudah diproses oleh Sinar Mutiara, dan sedang dalam pengiriman kembali ke pusat / cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Barang lelangan sudah sampai di pusat / cabang. Status gadai dipulihkan kembali menjadi BERJALAN.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DIKIRIM KE CABANG</h6>
                <p class="smallText mb-0">Barang lelangan sudah diterima dan sedang dikirim ke cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA CABANG - MENUNGGU PENGEMBALIAN</h6>
                <p class="smallText mb-0">Barang lelangan sudah diterima oleh cabang dan pembayaran terakhir sudah lunas. Menunggu pengembalian barang ke nasabah.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">SELESAI</h6>
                <p class="smallText mb-0">Barang lelangan sudah diterima oleh cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">AJUKAN WRITE OFF</h6>
                <p class="smallText mb-0">Barang lelangan hilang dan sedang diajukan untuk write off.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PEMBAYARAN DI VOID</h6>
                <p class="smallText mb-0">Pembayaran dibatalkan (void) setelah kwitansi dicetak.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">DITOLAK</h6>
                <p class="smallText mb-0">Pengajuan ditolak oleh Sinar Mutiara.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="m-create" title="Request Kirim Balik Baru" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Mengajukan request kirim balik baru.
            <b-form-group label="No. Faktur" class="mt-4">
                <b-input v-model="create.noFaktur" maxlength="50" />
            </b-form-group>
            <b-form-group label="Catatan">
                <b-form-select name="catatan" v-model="create.notes" :options="catatanDropdown" @keydown.enter="confirmRequestKirimBalik">
                </b-form-select>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="pgiBtn" @click="confirmRequestKirimBalik">
                    Ajukan Kirim Balik
                </b-button>
            </div>
        </b-modal>
        <ModalConfirm id="modal-confirm-reqKirimBalik" title="Konfirmasi Request Kirim Balik" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk request kirim balik faktur ini?" @submit="execRequestKirimBalik()" />
        <b-modal id="modal-confirm-tolak" @shown="focusRejectModal" title="Konfirmasi Tolak Kirim Balik" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting">
            <b-form id="tolakKirimBalikForm" @submit.prevent="tolakKirimBalik">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Keterangan" class="mb-0">
                        <b-form-input ref="keteranganTolakKirimBalik"
                        v-model="input.keteranganTolakKirimBalik"
                        name="keteranganTolakKirimBalik"
                        type="text"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelTolakKirimBalikBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeTolakKirimBalikBtn" :disabled="isSubmitting" type="submit" form="tolakKirimBalikForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <ModalConfirm id="modal-confirm-terima" title="Konfirmasi Terima Kirim Balik" :isSubmitting="isSubmitting" alertVariant="warning" :alertMessage="terimaAlertMessage" desc="Apakah anda yakin untuk menerima kirim balik barang ini?" @submit="terimaKirimBalik()" />
        <b-modal id="modal-kirim-cabang" :title="kirimCabang.canSendToHeadOffice ? 'Kirim Barang' : 'Kirim ke Cabang'" centered no-close-on-backdrop>
            <b-form id="kirimCabangForm" @submit.prevent="confirmKirimCabang">
                <b-form-group label="Tujuan" v-if="kirimCabang.canSendToHeadOffice">
                    <b-form-radio-group v-model="kirimCabang.toHeadOffice" name="toHeadOffice" :options="[{ value: false, text: 'Cabang' }, { value: true, text: 'Pusat' }]" />
                </b-form-group>
                <template v-if="!kirimCabang.toHeadOffice">
                    <b-form-group label="Nama Kurir">
                        <b-form-input v-model="kirimCabang.courierName" name="courierName" maxlength="100" required />
                    </b-form-group>
                    <b-form-group label="No. Resi" class="mb-0">
                        <b-form-input v-model="kirimCabang.noResi" name="noResi" maxlength="100" required />
                    </b-form-group>
                </template>
            </b-form>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="cancelKirimCabangBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeKirimCabangBtn" type="submit" form="kirimCabangForm">
                    Kirim
                </b-button>
            </template>
        </b-modal>
        <ModalConfirm id="modal-confirm-kirim-cabang" :title="'Konfirmasi Kirim ke ' + sendDestination" :isSubmitting="isSubmitting" :desc="'Apakah anda yakin untuk mengirim barang ini ke ' + sendDestination.toLowerCase() + '?'" @submit="execKirimCabang()" />
        <ModalConfirm id="modal-confirm-terima-cabang" title="Konfirmasi Terima di Cabang" :isSubmitting="isSubmitting" desc="Apakah anda yakin barang ini sudah diterima di cabang?" @submit="execTerimaCabang()" />
        <b-modal id="modal-update-location" title="Ubah Lokasi Barang" centered :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting" :hide-header-close="isSubmitting">
            <b-form id="updateLocationForm" @submit.prevent="execUpdateLocation">
                <b-form-group label="Lokasi Barang Saat Ini" class="mb-0">
                    <b-form-select v-model="updateLocationNotes" name="updateLocationNotes" :options="catatanDropdown" required>
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>-- Pilih lokasi barang --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" :disabled="isSubmitting" type="submit" form="updateLocationForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Simpan'}}
                </b-button>
            </template>
        </b-modal>
        <ModalAjukanBarangHilang id="modal-ajukan-barang-hilang" :gadaiId="activeItem.gadaiId" @submitted="getDataKirimBalik" />
        <b-modal id="modal-detail" title="Detail Kirim Balik" size="lg" hide-footer>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">Informasi Request</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Faktur</b-col>
                    <b-col>{{ activeItem.noFaktur }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col>
                        <b-badge v-if="statusBadge[activeItem.status]" :variant="statusBadge[activeItem.status].variant" :class="statusBadge[activeItem.status].class">{{ statusBadge[activeItem.status].text }}</b-badge>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="requestPurpose(activeItem)">
                    <b-col cols="4" class="detail-data-label">Keperluan</b-col>
                    <b-col>{{ requestPurpose(activeItem) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diajukan</b-col>
                    <b-col>{{ activeItem.createdBy }} <div class="smallText text-muted">{{ $helper.formatDateAndHour(activeItem.createdAt) }}</div></b-col>
                </b-row>
                <b-row class="mb-2" v-if="activeItem.processedAt">
                    <b-col cols="4" class="detail-data-label">Diproses SM</b-col>
                    <b-col>{{ $helper.formatDateAndHour(activeItem.processedAt) }}</b-col>
                </b-row>
                <b-row class="mb-2" v-if="activeItem.acceptedAt">
                    <b-col cols="4" class="detail-data-label">Diterima Pusat</b-col>
                    <b-col>{{ $helper.formatDateAndHour(activeItem.acceptedAt) }}</b-col>
                </b-row>
                <b-row class="mb-2" v-if="activeItem.keterangan">
                    <b-col cols="4" class="detail-data-label">Alasan Penolakan</b-col>
                    <b-col class="text-danger">{{ activeItem.keterangan }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">Barang</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Barang</b-col>
                    <b-col>{{ activeItem.jenis }} <div class="smallText text-muted">{{ activeItem.merk }} - {{ activeItem.tipe }}</div></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Lokasi</b-col>
                    <b-col>{{ activeItem.lokasi || '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Posisi Barang</b-col>
                    <b-col>{{ activeItem.statusBarang || '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Barang</b-col>
                    <b-col>{{ locationNote(activeItem.locationType) || '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Gadai</b-col>
                    <b-col>{{ activeItem.statusGadai || '-' }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4" v-if="activeItem.noKwitansi || activeItem.statusPembayaran">
                <h6 class="form-title">Pembayaran</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Pembayaran</b-col>
                    <b-col>{{ activeItem.statusPembayaran || '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Kwitansi</b-col>
                    <b-col>{{ activeItem.noKwitansi || '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Pembayaran</b-col>
                    <b-col>{{ activeItem.jenisPembayaran || '-' }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-0" v-if="activeItem.sendToBranchAt">
                <h6 class="form-title">Pengiriman ke Cabang</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kurir / No. Resi</b-col>
                    <b-col>{{ activeItem.courierName || '-' }} <div class="smallText text-muted">{{ activeItem.noResi || '-' }}</div></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Dikirim</b-col>
                    <b-col>{{ activeItem.sendToBranchBy || '-' }} <div class="smallText text-muted">{{ $helper.formatDateAndHour(activeItem.sendToBranchAt) }}</div></b-col>
                </b-row>
                <b-row class="mb-2" v-if="activeItem.branchReceivedAt">
                    <b-col cols="4" class="detail-data-label">Diterima Cabang</b-col>
                    <b-col>{{ activeItem.branchReceivedBy || '-' }} <div class="smallText text-muted">{{ $helper.formatDateAndHour(activeItem.branchReceivedAt) }}</div></b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import CONSTANTS from '@/constants'
import ModalAjukanBarangHilang from '@/components/baranghilang/ModalAjukanBarangHilang'

export default {
    name: 'kirim-balik',
    components: { ModalAjukanBarangHilang },
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            create: {
                noFaktur: "",
                notes: "Barang sudah di SM"
            },

            updateLocationNotes: null,
            terimaAlertMessage: "",

            kirimCabang: {
                courierName: "",
                noResi: "",
                canSendToHeadOffice: false,
                toHeadOffice: false
            },

            input:{
                show: 10,
                filterNoFaktur: null,
                filterCabang: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null,

                keteranganTolakKirimBalik: ""
            },
            fields: [
                { key: "noFaktur", label: "No Faktur" },
                { key: "diajukanOleh", label: "Diajukan oleh / pada" },
                { key: "barang", label: "Barang" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [
                { id: 0, name: 'Diajukan' },
                { id: 1, name: 'Pengiriman' },
                { id: 2, name: 'Diterima' },
                { id: 3, name: 'Ditolak' },
                { id: 4, name: 'Menunggu Pembayaran' },
                { id: 5, name: 'Dikirim ke Cabang' },
                { id: 6, name: 'Diterima Cabang - Menunggu Pengembalian' },
                { id: 7, name: 'Selesai' },
                { id: 8, name: 'Ajukan Write Off' },
                { id: 9, name: 'Pembayaran di Void' },
            ],
            statusBadge: {
                DIAJUKAN: { variant: 'dark', text: 'DIAJUKAN' },
                PENGIRIMAN: { variant: 'primary', text: 'PENGIRIMAN' },
                DITERIMA: { variant: 'success', text: 'DITERIMA' },
                DITOLAK: { variant: 'danger', text: 'DITOLAK' },
                MENUNGGU_PEMBAYARAN: { variant: 'warning', text: 'MENUNGGU PEMBAYARAN' },
                DIKIRIM_KE_CABANG: { variant: 'info', text: 'DIKIRIM KE CABANG' },
                DITERIMA_CABANG_MENUNGGU_PENGEMBALIAN: { variant: 'light', class: 'border', text: 'DITERIMA CABANG - MENUNGGU PENGEMBALIAN' },
                SELESAI: { variant: 'secondary', text: 'SELESAI' },
                AJUKAN_WRITE_OFF: { variant: 'light', class: 'border border-danger text-danger', text: 'AJUKAN WRITE OFF' },
                VOID_PEMBAYARAN_AFTER_PAYMENT: { variant: 'light', class: 'border border-danger text-danger', text: 'PEMBAYARAN DI VOID' },
            },

            // dropdown catatan kirim balik
            catatanDropdown: [
                {value: "Barang sudah di SM", text: "Barang sudah di SM"}, 
                {value: "Barang masih di cabang", text: "Barang masih di cabang"}
            ],
            
             // filterCabang: null,
            dataKirimBalik: [],
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            idActiveAction: null,

            activeItem: {}

        }
    }, 
    computed: {
        sendDestination() {
            return this.kirimCabang.toHeadOffice ? "Pusat" : "Cabang"
        },
        listParams() {
            return {
                page: this.page,
                size: this.size,
                filterNoFaktur: this.input.filterNoFaktur || null,
                filterCabang: this.input.filterCabang ? this.input.filterCabang.id : null,
                filterStatus: this.input.filterStatus,
                sortBy: this.input.sortBy,
                sortDesc: this.input.sortDesc,
            }
        },
    },
    methods: {

        focusRejectModal(){
            this.$refs.keteranganTolakKirimBalik.focus()
        },
        
        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show

            this.cabangOption = JSON.parse(localStorage.getItem("cabang")) || []

            let getDataKirimBalik = this.$axios.get("lelang-kirim-balik/", { params: this.listParams }).then(response => {
                this.dataKirimBalik = response.data.data
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })
            Promise.all([getDataKirimBalik]).then(() => {
                this.initStatus = 1
                this.isBusy = false
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        openModalConfirmTerima(item) {
            this.idActiveAction = item.id
            this.terimaAlertMessage = item.locationType == CONSTANTS.LELANG_KIRIM_BALIK.LOCATION_TYPE.DI_CABANG
                ? "Karena barang ini masih di cabang, barang ini akan otomatis diterima di cabang setelah anda menerima ini (tidak perlu input data pengiriman ke cabang!)"
                : ""
            this.$bvModal.show("modal-confirm-terima")
        },

        terimaKirimBalik() {

            let id = this.idActiveAction
            this.isSubmitting = true
            
            this.$axios.post(`lelang-kirim-balik/terima/?id=${id}`).then(response => {

                this.$helper.toastSucc(this, "Berhasil menerima kembali!")
                this.$bvModal.hide("modal-confirm-terima")
                this.getDataKirimBalik()

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        openModalKirimCabang(item) {
            this.idActiveAction = item.id
            this.kirimCabang.courierName = ""
            this.kirimCabang.noResi = ""
            this.kirimCabang.canSendToHeadOffice = item.intentionStatus == CONSTANTS.LELANG_KIRIM_BALIK.INTENTION_STATUS.WRITE_OFF
            this.kirimCabang.toHeadOffice = false
            this.$bvModal.show("modal-kirim-cabang")
        },

        confirmKirimCabang() {

            if(this.kirimCabang.toHeadOffice) {
                return this.$bvModal.show("modal-confirm-kirim-cabang")
            }

            if(this.$helper.isNullOrEmpty(this.kirimCabang.courierName.trim())) {
                return this.$helper.toastErr(this, "Mohon mengisi nama kurir!")
            }

            if(this.$helper.isNullOrEmpty(this.kirimCabang.noResi.trim())) {
                return this.$helper.toastErr(this, "Mohon mengisi no. resi!")
            }

            this.$bvModal.show("modal-confirm-kirim-cabang")

        },

        execKirimCabang() {

            this.isSubmitting = true

            const params = this.kirimCabang.toHeadOffice
                ? { id: this.idActiveAction, toHeadOffice: true }
                : {
                    id: this.idActiveAction,
                    courierName: this.kirimCabang.courierName.trim(),
                    noResi: this.kirimCabang.noResi.trim()
                }

            this.$axios.post("lelang-kirim-balik/send-to-branch", null, { params }).then(() => {

                this.$helper.toastSucc(this, "Berhasil mengirim ke " + this.sendDestination.toLowerCase() + "!")
                this.$bvModal.hide("modal-confirm-kirim-cabang")
                this.$bvModal.hide("modal-kirim-cabang")
                this.getDataKirimBalik()

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        openModalConfirmTerimaCabang(id) {
            this.idActiveAction = id
            this.$bvModal.show("modal-confirm-terima-cabang")
        },

        execTerimaCabang() {

            this.isSubmitting = true

            this.$axios.post("lelang-kirim-balik/accept-by-branch", null, { params: { id: this.idActiveAction } }).then(() => {

                this.$helper.toastSucc(this, "Berhasil menerima barang di cabang!")
                this.$bvModal.hide("modal-confirm-terima-cabang")
                this.getDataKirimBalik()

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        canRequestWriteOff(item) {
            if (item.status != 'AJUKAN_WRITE_OFF' || item.intentionStatus != CONSTANTS.LELANG_KIRIM_BALIK.INTENTION_STATUS.WRITE_OFF) return false
            if (item.locationType == CONSTANTS.LELANG_KIRIM_BALIK.LOCATION_TYPE.DI_CABANG) return this.$helper.hasPermissionMenuChildren('LOC')
            return this.$helper.hasPermissionMenuChildren(item.toHeadOffice ? 'LBW' : 'GDH')
        },

        locationNote(locationType) {
            if (locationType == CONSTANTS.LELANG_KIRIM_BALIK.LOCATION_TYPE.DI_SM) return "Barang sudah di SM"
            if (locationType == CONSTANTS.LELANG_KIRIM_BALIK.LOCATION_TYPE.DI_CABANG) return "Barang masih di cabang"
            return null
        },

        openModalUpdateLocation(item) {
            this.idActiveAction = item.id
            this.updateLocationNotes = this.locationNote(item.locationType)
            this.$bvModal.show("modal-update-location")
        },

        execUpdateLocation() {
            if (this.updateLocationNotes == null) {
                return this.$helper.toastErr(this, "Mohon memilih lokasi barang!")
            }

            this.isSubmitting = true

            const params = { id: this.idActiveAction, notes: this.updateLocationNotes }

            this.$axios.post("lelang-kirim-balik/update-location-type", null, { params }).then(() => {
                this.$helper.toastSucc(this, "Berhasil mengubah lokasi barang!")
                this.$bvModal.hide("modal-update-location")
                this.getDataKirimBalik()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isSubmitting = false
            })
        },

        openModalWriteOff(item) {
            this.activeItem = item
            this.$bvModal.show("modal-ajukan-barang-hilang")
        },

        requestPurpose(item) {
            if (item.intentionStatus == CONSTANTS.LELANG_KIRIM_BALIK.INTENTION_STATUS.PEMBAYARAN) return "PP/PL"
            if (item.intentionStatus == CONSTANTS.LELANG_KIRIM_BALIK.INTENTION_STATUS.WRITE_OFF) return "Barang Hilang"
            return null
        },

        openDetail(item) {
            this.$axios.get("lelang-kirim-balik/detail", { params: { id: item.id } }).then(response => {
                this.activeItem = { ...item, ...response.data }
                this.$bvModal.show("modal-detail")
            })
            .catch(error => this.$helper.parseError(this, error))
        },
        
        //----------------- Fungsi Ambil Data Cek Gadai -----------------

        getDataKirimBalik() {

            this.isBusy = true
            this.dataKirimBalik = []

            this.$axios.get("lelang-kirim-balik/", { params: this.listParams }).then(response => {
                this.dataKirimBalik = response.data.data
                this.updateTotalItem(response.data.total)
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(()=>{
                this.isBusy = false
                this.loading = false
            })

        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.getDataKirimBalik()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.getDataKirimBalik()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterNoFaktur = null
            this.input.filterCabang = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.loading = true
            this.getDataKirimBalik()
        },

        onFilter() {
            this.page = 0
            this.currentPage = 1
            this.loading = true
            this.getDataKirimBalik()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        confirmRequestKirimBalik() {

            if(this.$helper.isNullOrEmpty(this.create.noFaktur)) {
                return this.$helper.toastErr(this, "Mohon mengisi nomor faktur!")
            }

            if(this.$helper.isNullOrEmpty(this.create.notes)) {
                return this.$helper.toastErr(this, "Mohon mengisi catatan!")
            }

            this.$bvModal.show("modal-confirm-reqKirimBalik")

        },

        execRequestKirimBalik() {

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("noFaktur", this.create.noFaktur)
            payload.append("notes", this.create.notes)
            
            this.$axios.post(`lelang-kirim-balik/request-balik-sm`, payload).then(res => {

                this.$helper.toastSucc(this, "Request kirim balik berhasil diajukan")
                this.getDataKirimBalik()

                this.$bvModal.hide("modal-confirm-reqKirimBalik")
                this.$bvModal.hide("m-create")
                this.create.noFaktur = ""
                this.create.notes = ""

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

    },

    created(){
        this.init()
    }
}
</script>
